(function(){
  var RATES = { EUR:0.877, AUD:1.53, GBP:0.79, CAD:1.34, USD:1, NZD:1.68 };
  var COUNTRY_TO_CCY = {
    NL:'EUR', BE:'EUR', DE:'EUR', FR:'EUR', IT:'EUR', ES:'EUR', AT:'EUR', PT:'EUR', IE:'EUR', LU:'EUR',
    FI:'EUR', GR:'EUR', SK:'EUR', SI:'EUR', LV:'EUR', LT:'EUR', EE:'EUR', CY:'EUR', MT:'EUR',
    AU:'AUD', NZ:'NZD', GB:'GBP', CA:'CAD', US:'USD'
  };

  var cachedCurrency = null;

  function ceil(n){ return Math.ceil(n); }
  function fmt(n,c){
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:c}).format(n); }
    catch(e){ var s={USD:'$',EUR:'€',AUD:'A$',GBP:'£',CAD:'C$','NZD':'NZ$'}; return (s[c]||'')+n; }
  }
  function qsa(sel,root){ return (root||document).querySelectorAll(sel); }

  function convertAll(code){
    qsa('.dyn-price[data-usd]').forEach(function(el){
      var base = parseFloat(el.getAttribute('data-usd')); if (isNaN(base)) return;
      var rate = RATES[code] || 1;
      var amount = (code === 'USD') ? base : ceil(base * rate);
      el.textContent = fmt(amount, code);
    });
  }

  function detectCurrency(){
    // Return cached currency if already detected
    if (cachedCurrency) {
      return Promise.resolve(cachedCurrency);
    }

    // Try cookie first
    var m = document.cookie.match(/(?:^|;\s*)shopify_country=([A-Z]{2})/);
    var country = m ? m[1] : (window.Shopify && Shopify.country) || null;
    
    if (country && COUNTRY_TO_CCY[country]) {
      cachedCurrency = COUNTRY_TO_CCY[country];
      return Promise.resolve(cachedCurrency);
    }
    
    // Try Shopify's built-in currency
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      cachedCurrency = Shopify.currency.active;
      return Promise.resolve(cachedCurrency);
    }

    // Fallback to USD
    cachedCurrency = 'USD';
    return Promise.resolve(cachedCurrency);
  }

  function refresh(){ detectCurrency().then(convertAll); }

  // Debounced observer to prevent excessive calls
  var debounceTimer;
  function debouncedRefresh(){
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 100);
  }

  function start(){
    refresh();
    var obs = new MutationObserver(debouncedRefresh);
    obs.observe(document.documentElement, { childList:true, subtree:true });
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();